import { SortingState } from "@tanstack/react-table";
import { ReactNode } from "react";

import { PaymentsInvoice } from "~/api/Api";

import { Pagination, PaginationConfig } from "../ui/pagination/Pagination";
import styles from "./Invoices.module.scss";
import { InvoicesTable } from "./InvoicesTable";

type InvoicesProps = {
  invoices: PaymentsInvoice[];
  getInvoiceStripeUrl: (id: number) => void;
  downloadInvoice: (id: number) => void;
  isLoadingDownloadInvoice: boolean;
  isLoadingGetInvoiceStripeUrl: boolean;
  pagination: PaginationConfig;
  setPagination: (pagination: PaginationConfig) => void;
  isLoading: boolean;
  isFetching: boolean;
  sorting: SortingState;
  onSortingChange: (sorting: SortingState) => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  toolbarActions?: ReactNode;
};

export const Invoices = ({
  invoices,
  getInvoiceStripeUrl,
  downloadInvoice,
  isLoadingDownloadInvoice,
  isLoadingGetInvoiceStripeUrl,
  isLoading,
  pagination,
  setPagination,
  isFetching,
  sorting,
  onSortingChange,
  searchValue,
  onSearchChange,
  toolbarActions,
}: InvoicesProps) => {
  return (
    <main className={styles.page}>
      <InvoicesTable
        invoices={invoices}
        getInvoiceStripeUrl={getInvoiceStripeUrl}
        downloadInvoice={downloadInvoice}
        isLoadingDownloadInvoice={isLoadingDownloadInvoice}
        isLoadingGetInvoiceStripeUrl={isLoadingGetInvoiceStripeUrl}
        isLoading={isLoading}
        isFetching={isFetching}
        sorting={sorting}
        onSortingChange={onSortingChange}
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        toolbarActions={toolbarActions}
      />

      <Pagination
        {...pagination}
        totalItems={pagination.totalItems}
        onPageChange={(page) =>
          setPagination({ ...pagination, currentPage: page })
        }
        onItemsPerPageChange={(items) =>
          setPagination({ ...pagination, itemsPerPage: items })
        }
        isLoading={isFetching}
      />
    </main>
  );
};
